import { useState, useEffect } from 'react';
import { Button } from "primereact/button";

import ModalSeplag from '../../../components/ModalSeplag';
import TableSeplag from '../../../components/TableSeplag'
import CardSeplag from '../../../components/CardSeplag'

import Timeline from '../../../pages/Auditoria/components/Timeline';
import CustomizedContent from './components/CustomizedContent';

import { buscarLogPorTipoCertidao
 } from '../../../service/Audit/TipoCertidao';
import {
  pesquisarAll as pesquisaAtivos,
  buscarPeloCodigo as buscarIdenCertidao,
  FormTipoCertidao as initForm,
 } from '../../../service/manterTiposCertidao';

const TipoCertidao = () => {

  const [formDataModalTipoCertidao, setFormDataModalTipoCertidao] = useState(initForm);
  const [edit, setEdit] = useState(false);
  const [showForm, setShowForm] = useState(false)
  const [viewCamposModalTipoCertidao, setViewCamposModalTipoCertidao] = useState(false);
  const [listaTipoCertidao, setlistaTipoCertidao] = useState([]);
  const [tipoCertidaoSelected, setTipoCertidaoSelected] = useState();
  const [logs, setLogs] = useState([]);
  const [visible, setVisible] = useState(false);

  
  useEffect(async () => {
    let data = await pesquisaAtivos();

    setlistaTipoCertidao(data.map(function (element) {
      let novoElement = {
        ...element,
        amparoLegal: null,
        listaAmparoLegalTpCertidao: element.listaAmparoLegalTpCertidao.map(function (element2) {
          return { ...element2.amparoLegal }
        })
      }
      if (element.amparoLegal) {
        novoElement.listaAmparoLegalTpCertidao.push(element.amparoLegal)
      }
      return novoElement
    })
    );
  }, []);

  const handleShowModalAdicionarTipoCertidao = async () => {
    setShowForm(true);
    setViewCamposModalTipoCertidao(false);
    setEdit(false);

    let resetFormDataModalTipoCertidao = {
      tipoCertidao: {
        idenTipoCertidao: null
      },
      codgTipoCertidao: null,
      nomeTipoCertidao: '',
      siglTipoCertidao: '',
      orgaoEmissor: null
    }

    setFormDataModalTipoCertidao(resetFormDataModalTipoCertidao);
  };

const handleSearch = async (inputValue) => {
    const rowData = await buscarIdenCertidao(inputValue);
    setlistaTipoCertidao([rowData])
  }

const showModalLog = (rowData) => {
    setTipoCertidaoSelected({ ...rowData });
    buscarLogPorTipoCertidao(rowData.idenTipoCertidao).then((res) => {
      setLogs(res.filter((element) => element.auditoriaDTO));
       setVisible(true);
    });
  };

  const camposTabela = [
    { nome: "codgTipoCertidao", titulo: "Codg. Tipo" },
    { nome: "siglTipoCertidao", titulo: "Sigla" },
    { nome: "nomeTipoCertidao", titulo: "Nome do Tipo" },
  ];
    
  const botoesAcoes = (rowData) => {
    return <Button 
    icon="pi pi-list" 
    tooltip="log" 
    tooltipOptions={{ position: "left" }} 
    onClick={() => showModalLog(rowData)} />;
  };  

  return (
    <CardSeplag title="Tipos de Certidão">
      <TableSeplag dados={listaTipoCertidao} camposTabela={camposTabela} searchPlaceholder="Pesquisar tipo pelo código"
        onSearch={handleSearch} hasEventoAcao botoesAcoes={botoesAcoes} />   
        {visible && (
            <ModalSeplag
              type="NONE"
              titulo={`Log do Tipo: ${tipoCertidaoSelected.nomeTipoCertidao}`}
              visible={visible}
              fechar={() => setVisible(false)}
              maximizable
            >
              <Timeline
                logs={logs}
                customizedContent={CustomizedContent}
              />   
               
            </ModalSeplag>
          )}           
          
    </CardSeplag>
  );
}

export default TipoCertidao;
